/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CeaInfindProperties from '../model/CeaInfindProperties';
import FindKnowledgeGraphRelationshipValuesRequest from '../model/FindKnowledgeGraphRelationshipValuesRequest';
import FindKnowledgeGraphRelationshipValuesResponse from '../model/FindKnowledgeGraphRelationshipValuesResponse';
import FindKnowledgeGraphValuesFromRelationshipsResponse from '../model/FindKnowledgeGraphValuesFromRelationshipsResponse';
import ItemOfFindCeasByCtaRequest from '../model/ItemOfFindCeasByCtaRequest';
import ItemOfFindCeasByCtaResponse from '../model/ItemOfFindCeasByCtaResponse';
import ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest from '../model/ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest';
import Property from '../model/Property';

/**
* KnowledgeGraph service.
* @module endpoints/KnowledgeGraphApi
* @version 2.8.0
*/
export default class KnowledgeGraphApi {

    /**
    * Constructs a new KnowledgeGraphApi. 
    * @alias module:endpoints/KnowledgeGraphApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get list of cea
     * @param {Array.<module:model/ItemOfFindCeasByCtaRequest>} itemOfFindCeasByCtaRequest head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ItemOfFindCeasByCtaResponse>} and HTTP response
     */
    findCeasByCtaWithHttpInfo(itemOfFindCeasByCtaRequest) {
      let postBody = itemOfFindCeasByCtaRequest;
      // verify the required parameter 'itemOfFindCeasByCtaRequest' is set
      if (itemOfFindCeasByCtaRequest === undefined || itemOfFindCeasByCtaRequest === null) {
        throw new Error("Missing the required parameter 'itemOfFindCeasByCtaRequest' when calling findCeasByCta");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = [ItemOfFindCeasByCtaResponse];
      return this.apiClient.callApi(
        '/knowledgeGraph/cea/findByCta', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get list of cea
     * @param {Array.<module:model/ItemOfFindCeasByCtaRequest>} itemOfFindCeasByCtaRequest head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ItemOfFindCeasByCtaResponse>}
     */
    findCeasByCta(itemOfFindCeasByCtaRequest) {
      return this.findCeasByCtaWithHttpInfo(itemOfFindCeasByCtaRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Find Knowledge Graph Relationship values
     * @param {module:model/FindKnowledgeGraphRelationshipValuesRequest} findKnowledgeGraphRelationshipValuesRequest head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/FindKnowledgeGraphRelationshipValuesResponse} and HTTP response
     */
    findKnowledgeGraphRelationshipValuesWithHttpInfo(findKnowledgeGraphRelationshipValuesRequest) {
      let postBody = findKnowledgeGraphRelationshipValuesRequest;
      // verify the required parameter 'findKnowledgeGraphRelationshipValuesRequest' is set
      if (findKnowledgeGraphRelationshipValuesRequest === undefined || findKnowledgeGraphRelationshipValuesRequest === null) {
        throw new Error("Missing the required parameter 'findKnowledgeGraphRelationshipValuesRequest' when calling findKnowledgeGraphRelationshipValues");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = FindKnowledgeGraphRelationshipValuesResponse;
      return this.apiClient.callApi(
        '/knowledgeGraph/findRelationshipValues', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Find Knowledge Graph Relationship values
     * @param {module:model/FindKnowledgeGraphRelationshipValuesRequest} findKnowledgeGraphRelationshipValuesRequest head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/FindKnowledgeGraphRelationshipValuesResponse}
     */
    findKnowledgeGraphRelationshipValues(findKnowledgeGraphRelationshipValuesRequest) {
      return this.findKnowledgeGraphRelationshipValuesWithHttpInfo(findKnowledgeGraphRelationshipValuesRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Find Knowledge Graph values from Relationships
     * @param {Array.<module:model/ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest>} itemOfFindKnowledgeGraphValuesFromRelationshipsRequest head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/FindKnowledgeGraphValuesFromRelationshipsResponse} and HTTP response
     */
    findKnowledgeGraphValuesFromRelationshipsWithHttpInfo(itemOfFindKnowledgeGraphValuesFromRelationshipsRequest) {
      let postBody = itemOfFindKnowledgeGraphValuesFromRelationshipsRequest;
      // verify the required parameter 'itemOfFindKnowledgeGraphValuesFromRelationshipsRequest' is set
      if (itemOfFindKnowledgeGraphValuesFromRelationshipsRequest === undefined || itemOfFindKnowledgeGraphValuesFromRelationshipsRequest === null) {
        throw new Error("Missing the required parameter 'itemOfFindKnowledgeGraphValuesFromRelationshipsRequest' when calling findKnowledgeGraphValuesFromRelationships");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = FindKnowledgeGraphValuesFromRelationshipsResponse;
      return this.apiClient.callApi(
        '/knowledgeGraph/findValuesFromRelationships', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Find Knowledge Graph values from Relationships
     * @param {Array.<module:model/ItemOfFindKnowledgeGraphValuesFromRelationshipsRequest>} itemOfFindKnowledgeGraphValuesFromRelationshipsRequest head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/FindKnowledgeGraphValuesFromRelationshipsResponse}
     */
    findKnowledgeGraphValuesFromRelationships(itemOfFindKnowledgeGraphValuesFromRelationshipsRequest) {
      return this.findKnowledgeGraphValuesFromRelationshipsWithHttpInfo(itemOfFindKnowledgeGraphValuesFromRelationshipsRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get list of properties
     * @param {Array.<module:model/CeaInfindProperties>} ceaInfindProperties head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Property>} and HTTP response
     */
    findPropertiesWithHttpInfo(ceaInfindProperties) {
      let postBody = ceaInfindProperties;
      // verify the required parameter 'ceaInfindProperties' is set
      if (ceaInfindProperties === undefined || ceaInfindProperties === null) {
        throw new Error("Missing the required parameter 'ceaInfindProperties' when calling findProperties");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AuthJWT'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = [Property];
      return this.apiClient.callApi(
        '/knowledgeGraph/cpa/findProperties', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get list of properties
     * @param {Array.<module:model/CeaInfindProperties>} ceaInfindProperties head
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Property>}
     */
    findProperties(ceaInfindProperties) {
      return this.findPropertiesWithHttpInfo(ceaInfindProperties)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
